// Bedbank offer description uses this marker to split "main" vs expandable content.
export const BEDBANK_DESCRIPTION_SPLIT_MARKER = '####' as const
